import { AbstractPmsApiService } from "./abstract.service";
import {Closeout} from "../models/closeout.model";

/**
 * @class CloseoutService
 * @abstract
 * @extends {AbstractPmsApiService<CloseoutService>}
 */
export class CloseoutService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/closeouts(/:id)';
    }

    newModel(attributes) {

        return new Closeout(attributes);
    }

    get(property, params) {

        const url = this.url({propertyId: property.id});

         return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    create(model, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(model, property) {

        const url = this.url({propertyId: property.id, id: model.id});

        return this.http
            .put(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    delete(model) {

        const url = this.url({
            propertyId: model.property.id,
            id: model.id,
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/closeout.service.js